import { accAdd, accMul } from '../assets/js/public.js'

export const ROW_TYPE_PRODUCT = 'product'
export const ROW_TYPE_EXTRA = 'extra'

export function isExtraTableRow(row) {
	return !!(row && row._rowType === ROW_TYPE_EXTRA)
}

/** 费用项数量：缺省 / 非法时按 1 */
export function extraFeeQty(row) {
	if (!row) return 1
	const raw = row.qty != null && row.qty !== '' ? row.qty : row.goods_num
	const qty = Number(raw)
	if (Number.isFinite(qty) && qty > 0) return qty
	return 1
}

/** 费用项单价：优先 unit_price；旧数据仅有金额时按 金额/数量 反推 */
export function extraFeeUnitPrice(row) {
	if (!row) return 0
	const unit = Number(row.unit_price != null && row.unit_price !== '' ? row.unit_price : row.singleton)
	if (Number.isFinite(unit) && unit > 0) return Number(unit.toFixed(2))
	const amount = Number(row.amount)
	const qty = extraFeeQty(row)
	if (Number.isFinite(amount) && amount > 0 && qty > 0) {
		return Number((amount / qty).toFixed(2))
	}
	return 0
}

/** 行金额 = 单价 × 数量 */
export function extraFeeLineAmount(row) {
	const unit = extraFeeUnitPrice(row)
	const qty = extraFeeQty(row)
	if (!(unit > 0) || !(qty > 0)) return 0
	return Number(accMul(unit, qty).toFixed(2))
}

export function normalizeExtraFeeLine(row) {
	if (!row) return null
	const qty = extraFeeQty(row)
	const unit = extraFeeUnitPrice(row)
	const amount = extraFeeLineAmount(row)
	return {
		extra_item_id: row.extra_item_id,
		name: String(row.name || ''),
		qty,
		unit_price: unit > 0 ? Number(unit.toFixed(2)) : '',
		amount: amount > 0 ? Number(amount.toFixed(2)) : '',
		remark: String(row.remark || row.remarks || ''),
	}
}

function extraTablePayload(row, index) {
	const norm = normalizeExtraFeeLine(row) || {}
	const qty = norm.qty || 1
	return {
		_rowType: ROW_TYPE_EXTRA,
		_extraIndex: index,
		extra_item_id: row && row.extra_item_id,
		name: (row && row.name) || '',
		qty,
		unit_price: norm.unit_price,
		amount: norm.amount,
		remark: (row && row.remark) || '',
		remarks: (row && (row.remark || row.remarks)) || '',
		parameter_text: '附加费用',
		goods_unit: '项',
		goods_num: qty,
		singleton: norm.unit_price,
	}
}

/** 编辑态：产品 + 附加费合并为一张表（产品在前，附加费在后） */
export function mergeEditableTableRows(cartList, extraFeeLines) {
	const products = (cartList || []).map(function(row, index) {
		return Object.assign({}, row, {
			_rowType: ROW_TYPE_PRODUCT,
			_cartIndex: index,
		})
	})
	const extras = (extraFeeLines || []).map(function(row, index) {
		return extraTablePayload(row, index)
	})
	return products.concat(extras)
}

/** 只读态：产品清单 + 附加费（报价单用；加工/发货单传 includeExtras: false） */
export function mergeReadonlyTableRows(goodslist, extraFees, options) {
	const opts = options || {}
	const includeExtras = opts.includeExtras !== false
	const products = (goodslist || []).map(function(row, index) {
		return Object.assign({}, row, {
			_rowType: ROW_TYPE_PRODUCT,
			_cartIndex: index,
		})
	})
	if (!includeExtras) return products
	const extras = (extraFees || []).map(function(row, index) {
		return extraTablePayload(row, index)
	})
	return products.concat(extras)
}

/** 过滤有效附加费行（已选字典项且行金额 > 0） */
export function validExtraFeeLines(lines) {
	const list = Array.isArray(lines) ? lines : []
	return list.map(function(row) {
		if (!row) return null
		const id = Number(row.extra_item_id)
		const norm = normalizeExtraFeeLine(row)
		if (!(id > 0) || !norm) return null
		const amount = Number(norm.amount)
		if (!Number.isFinite(amount) || !(amount > 0)) return null
		return {
			extra_item_id: id,
			name: String(norm.name || ''),
			qty: Number(norm.qty),
			unit_price: Number(norm.unit_price),
			amount: Number(amount.toFixed(2)),
			remark: String(norm.remark || ''),
		}
	}).filter(Boolean)
}

/** 附加费用合计（按单价 × 数量） */
export function sumExtraFeeLines(lines) {
	let total = 0
	validExtraFeeLines(lines).forEach(function(row) {
		total = accAdd(total, row.amount)
	})
	return Number(total).toFixed(2)
}

/** 提交给后端的 JSON 字符串 */
export function serializeExtraFees(lines) {
	return JSON.stringify(validExtraFeeLines(lines))
}

/** Excel/导出：附加费行转为与产品相同的列数组 */
export function buildExtraFeeGoodsRow(fee, index, showSize, showAreas) {
	const norm = normalizeExtraFeeLine(fee) || {}
	const row = [index + 1, fee.name || '']
	if (showSize) row.push('-')
	row.push('-')
	if (showAreas) row.push('-')
	const qty = norm.qty || 1
	const unitText = norm.unit_price != null && norm.unit_price !== ''
		? '¥ ' + Number(norm.unit_price).toFixed(2)
		: '-'
	const amountText = norm.amount != null && norm.amount !== ''
		? '¥ ' + Number(norm.amount).toFixed(2)
		: ''
	row.push(qty, '项', unitText, amountText, fee.remark || '无')
	return row
}
